module.exports = __webpack_public_path__ + "media/video-mobile.1bb678ae.mp4";